interface EventParams {
  [key: string]: any;
}

function objectToStringFix(object: Record<string, unknown>) {
  if (!object) return null;
  const copy: any = JSON.parse(JSON.stringify(object));
  for (const [key, value] of Object.entries(copy)) {
    if (typeof value === 'object' && value !== null) {
      copy[key].toString = function () {
        return JSON.stringify(this);
      };
    }
  }
  return copy;
}

export const trackGtag = (eventName: string, params: EventParams = {}): void => {
  if (typeof window.gtag !== 'function') {
    return;
  }

  const eventParams: EventParams = {
    ...objectToStringFix(params),
  };

  window.gtag('event', eventName, eventParams);
  console.log('event', eventName, eventParams);
};

export const trackGtagRenew = (eventName: string, params: EventParams = {}): void => {
  trackGtag(eventName, {
    label: 'carIns',
    category: 'renewal',
    ...params,
  });
};

export const trackSendForm = (eventName: string, phone: string, place?: string) => {
  trackGtag(eventName, {
    label: 'main_page',
    section: 'body',
    page: 'landing',
    place: place === 'error' ? 'popup_error_request_callback' : 'popup_request_callback',
    phone,
  });
};
